import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import { API_CONFIG, API_LIST } from '../../Constants/ApiDefinations'
import { CreateMastersData, DownstreamPlatformsListResponse } from '../../Models'
import mainApiService from '../../Services'
import { setLoader } from './loader.slice'

interface DownstreamPlatformsState {
  downstreamPlatformData: DownstreamPlatformsListResponse | null
}

const initialState: DownstreamPlatformsState = {
  downstreamPlatformData: null,
}

const downstreamPlatformsSlice = createSlice({
  name: 'downstreamPlatforms',
  initialState,
  reducers: {
    setDownstreamPlatformsData: (state, action) => {
      state.downstreamPlatformData = action?.payload ? action.payload : null
    },
  },
})

export const { setDownstreamPlatformsData } = downstreamPlatformsSlice.actions

const downstreamPlatformsSelector = (state: any) => state.downstreamPlatforms

export const selectDownstreamPlatformData = createSelector(
  downstreamPlatformsSelector,
  (state) => state.downstreamPlatformData,
)

export const createDownstreamPlatformService = createAsyncThunk(
  'downstreamPlatforms/create',
  async (payload: CreateMastersData, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(
      API_LIST.MASTER_APIS.ADD_SYSTEM_CONFIG,
      {
        value: { key: payload.key, status: payload.status, value: payload.value },
        master: 'DOWNSTREAMPLATFORMS',
      },
      { type: 'DOWNSTREAMPLATFORMS' },
    )
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)

export const editDownstreamPlatformService = createAsyncThunk(
  'downstreamPlatforms/editDownstreamPlatform',
  async (payload: CreateMastersData, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(
      API_LIST.MASTER_APIS.ADD_SYSTEM_CONFIG,
      {
        value: { key: payload.key, status: payload.status, value: payload.value },
        master: 'DOWNSTREAMPLATFORMS',
        systemConfigId: payload?.id,
      },
      {
        type: 'DOWNSTREAMPLATFORMS',
      },
    )
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)

export default downstreamPlatformsSlice
